import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { DepartureAirportFilterComponentLegacy } from '@/scopes/search/components/DepartureAirportFilterComponentLegacy'
import { GroupedDepartureAirportFilterComponentLegacy } from '@/scopes/search/components/GroupedDepartureAirportFilterComponentLegacy'
import { useQuickSearchStore } from '@/scopes/search/components/QuickSearchBarLegacy/store'
import { createSearchFilterClickEvent } from '@/scopes/search/search/domain/analytics'
import { useMultiSelectFilter } from '@/scopes/search/search/domain/hooks'
import { isEmpty } from 'ramda'
import * as React from 'react'

export function DepartureAirportQuickSearchItemFilterLegacy() {
  const { isFetching, options, setSelection, selectedOptions } = useMultiSelectFilter('DepartureAirport')
  const { setActiveItem } = useQuickSearchStore()
  const { sendEvent } = useAnalytics()

  const handleConfirm = (selection: string[]) => {
    if (!isFetching) {
      setSelection(selection)

      if (selection.length) {
        sendEvent(
          createSearchFilterClickEvent({
            element: 'checkbox',
            type: 'airports',
            result: selection.join(','),
          }),
        )
      }
    }
    setActiveItem(null)
  }

  if (isEmpty(options)) {
    return null
  }
  const showGroups = options.filter(o => o.groupInfo).length > 0

  const FilterComponent = showGroups ? GroupedDepartureAirportFilterComponentLegacy : DepartureAirportFilterComponentLegacy

  return (
    <FilterComponent
      onConfirm={handleConfirm}
      options={options}
      selectedOptions={selectedOptions}
      disabled={isFetching}
    />
  )
}
